import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileListItem } from '@mobileTypes'

export const MOBILE_LIST_ITEMS_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
  },
]

export const DEFAULT_MOBILE_LIST_ITEM: Omit<MobileListItem, 'id'> = {
  internalId: '',
  title: '',
  itemType: 'dictionary',
  // Validation requires at least one row in "simple" mode,
  // so new config starts with a single empty row.
  rows: [{ elements: [] }],
  getDataCommands: null,
  dataSource: {
    bindType: 'command',
  },
  configMode: 'simple',
  itemTemplate: undefined,
  variables: [],
  eventFlows: [],
  enableSearch: false,
  searchFields: [],
}
